import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import JobTool from './components/JobTool';
import BranchArticle from './components/articles/branchArticle';
import ConsultantArticle from './components/articles/consultantArticle';
import DefaultArticle from './components/articles/defaultArticle';
import EventArticle from './components/articles/eventArticle';
import ExternalArticle from './components/articles/externalArticle';
import PressReleaseArticle from './components/articles/pressReleaseArticle';
import ReportArticle from './components/articles/reportArticle';
import Landingpage from './components/landingpage/landingpage';
import { Search } from './components/search';
import i18n from './i18n';

function calculateArticleHeight($section, containerSelector, sectionHeight = '95%') {
  const isSmallScreen = document.body.clientWidth < 800;
  const $sectionContainer = $section.find(containerSelector);
  const $scrollDownElement = $section.find('.fotorama__arr--down');

  if ($sectionContainer.length) {
    $section.height(sectionHeight);

    const articleContainerHeight = $section.outerHeight() || 0;
    const contentContainerHeight = $sectionContainer.outerHeight() || 0;
    // * 2.5 because real element height is calculated too small somehow + adding some spacing
    const scrollDownElementHeight = $scrollDownElement.outerHeight() * 2.5 || 0;

    if (articleContainerHeight < contentContainerHeight + scrollDownElementHeight) {
      let calculatedArticleHeight = contentContainerHeight + scrollDownElementHeight;

      if (isSmallScreen) {
        // add small screen navigation height to prevent overlaying operating elements
        const smallScreenNavigationHeight = $('.mobile-navigation').outerHeight();

        // it is around 58.5px, thats why this is the fallback value when not fully loaded yet,
        // what we know when the height is smaller than 10
        calculatedArticleHeight +=
          smallScreenNavigationHeight <= 10 ? 58.5 : smallScreenNavigationHeight;
      }

      $section.height(calculatedArticleHeight);
    }
  }
}

/**
 * calculate article heights on three triggers:
 *
 *   - directly on call, initially
 *   - when images are load, because images resize inner containers
 *   - on window resizing, to adjust containers with screen size
 */
function initArticleHeightCalculations(
  $section,
  containerSelector = '.fullscreen .container',
  sectionHeight = '95%'
) {
  calculateArticleHeight($section, containerSelector, sectionHeight);

  $section.find('img').on('load', () => {
    calculateArticleHeight($section, containerSelector, sectionHeight);
  });

  $(window).resize(() => {
    calculateArticleHeight($section, containerSelector, sectionHeight);
  });
}

// calculate correct heights for fullscreen sections of one pagers
// to prevent multiple scroll bars if content exceeds 100% height
function correctArticleHeight(articleId) {
  setTimeout(() => {
    const $section = $(`section[data-article-id="${articleId}"].one-pager`);

    // do nothing if the section is no one pager
    if (!$section.length) return;

    // is this one pager section a fullscreen section?
    const isFullscreenSection = [...$section[0].children]
      .map((child) => child.className.includes('fullscreen'))
      .includes(true);

    // do nothing if the section is no fullscreen one pager
    if (!isFullscreenSection) return;

    initArticleHeightCalculations($section);
  }, 250);
}

// calculate correct heights for fotorama sections to prevent multiple scroll bars if content
// exceeds 100% height
function correctFotoramaArticleHeight($section) {
  const containerSelector = '.fotorama__active .container';

  initArticleHeightCalculations($section, containerSelector);
}

// if there is a color set for the article content, set this color also to the list items
// for this container
function contentListItemColor() {
  const $contentListItem = $('.content li span');

  if ($contentListItem.length) {
    $contentListItem.each(function() {
      const listItemColor = $(this).css('color');

      if (listItemColor !== undefined) {
        $(this)
          .parent()
          .css('color', listItemColor);
      }
    });
  }
}

// if there is a color set for the article content, set this color also to the breadcrumb
function breadcrumbColor() {
  const $breadCrumbHeadline = $('.breadcrumb-headline');

  if ($breadCrumbHeadline.length) {
    $breadCrumbHeadline.each(function() {
      const contentColor = $(this)
        .next()
        .find('span[style^="color"]')
        .css('color');

      if (contentColor !== undefined) {
        $(this)
          .children('.breadcrumb')
          .css('color', contentColor);
      }
    });
  }
}

// hides article content and shows a disclaimer instead, if a .liquid-disclaimer is found
function showDisclaimer() {
  const $disclaimer = $('.liquid-disclaimer'),
        $articleContent = $('article.content'),
        disclaimerButtons = `
          <div>
            <button class="disclaimer-yes button-left">Ja</button>
            <button class="disclaimer-no">Nein</button>
            <div class="disclaimer-warning" style="display: none;">
              <p>
                Der Disclaimer wurde abgelehnt. Die von Ihnen gewünschten Informationen können
                nicht angezeigt werden.
              </p>
            </div>
          </div>
        `;

  if ($disclaimer.length) {
    const disclaimerContent = `
      <div class="content disclaimer">
        ${$disclaimer.html() + disclaimerButtons}
      </div>
    `;

    $articleContent.hide();
    $disclaimer.remove();
    $articleContent.after(disclaimerContent);

    $('.disclaimer-yes').on('click', () => {
      $('.content.disclaimer').remove();
      $articleContent.show();
    });

    $('.disclaimer-no').on('click', () => {
      $('.disclaimer-warning').fadeIn();
    });
  }
}

// add scroll down html element to a section on a one pager if it is a fullscreen section
// and if there is another section coming afterwards
function addScrollDownElementOnSectionIfFullscreen(isFullscreenOnepager, articleId) {
  if (!isFullscreenOnepager) return;

  const currentArticleContainerSelector = `.article-container[data-article-id="${articleId}"]`;
  const currentArticleContainer = $(currentArticleContainerSelector)[0];

  if (!currentArticleContainer) return;

  const followingArticleContainer = $(
    `${currentArticleContainerSelector} + .article-container[data-article-id]`
  ).length;

  if (!followingArticleContainer) return;

  // is a scroll down element already bound?
  const scrollDownElementPresent = [...currentArticleContainer.children]
    .map((child) => child.className.includes('fotorama__arr fotorama__arr--down'))
    .includes(true);
  if (scrollDownElementPresent) return;

  // HTML for scroll down element
  const scrollDownElement = `
      <div
        class="fotorama__arr fotorama__arr--down"
        tabindex="0"
        role="button"
      >
      </div>
    `;

  // add scroll down element to the DOM
  $(currentArticleContainer).append(scrollDownElement);

  // add click handler to the scroll down element that triggers a click on the corresponding
  // button in the vertical navigation
  $(currentArticleContainer)
    .find('.fotorama__arr--down')
    .on('click', function() {
      const idToSlideTo = $(this)
        .closest('.article-container')
        .next()
        .attr('id');

      if ($(`.vertical-navigation [href="#${idToSlideTo}"]`).length) {
        $(`.vertical-navigation [href="#${idToSlideTo}"]`).click();
      }
    });
  // });
}

// determine and return component for article type
function componentForArticleType(slideArticleId, slideArticleType, slideArticleLanguage = 'de') {
  let component;

  switch (slideArticleType) {
    case 'branch':
      component = <BranchArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'consultant':
      component = <ConsultantArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'event':
      component = <EventArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'pressrelease':
      component = <PressReleaseArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'report':
      component = <ReportArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'external':
      component = <ExternalArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
    case 'landingpage':
      component = <Landingpage articleId={slideArticleId} key={slideArticleId} />;
      break;
    default:
      component = <DefaultArticle articleId={slideArticleId} key={slideArticleId} />;
      break;
  }

  // translate to English
  if (slideArticleLanguage === 'en') {
    i18n.changeLanguage(slideArticleLanguage);
  }

  return (
    <I18nextProvider i18n={i18n} key={`i18n-${slideArticleId}`}>
      {component}
    </I18nextProvider>
  );
}

// select first h3 in sidebar and set top margin to 0 on desktops.
// this makes the content start on same height like main-contents content.
function fixFurtherContentHeadlineMargin() {
  const $furtherContentH3s = $('.further-content h3'),
        isSmallWidth = document.body.clientWidth < 800;

  if ($furtherContentH3s.length && !isSmallWidth) {
    $furtherContentH3s.first().addClass('no-margin-top');
  }
}

// calculate the same heights for all contents with background on multiple columns article
function adjustContentWithBackgroundHeights() {
  const $contentsWithBackground = $('.multiple-column-articles .content-with-background'),
        isSmallWidth = document.body.clientWidth < 800;

  if ($contentsWithBackground.length > 1 && !isSmallWidth) {
    let maxHeight = 0;

    $contentsWithBackground.each(function() {
      const h = $(this).height();

      if (h > maxHeight) {
        maxHeight = h;
      }
    });

    $contentsWithBackground.height(maxHeight);
  }
}

function initModalRevealsForArticle(articleId) {
  const $modalRevealsForArticle = $(`[data-article-id="${articleId}"] [data-auto-reveal="true"]`);

  if ($modalRevealsForArticle.length) {
    $modalRevealsForArticle.each(function() {
      const $this = $(this);

      $this.on('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        const modalRevealId = $this.data('reveal-id');
        const $reveal = $(`#${modalRevealId}`);

        if ($reveal.length) {
          $reveal.reveal();
        }
      });
    });

    // prevent scrolling body when opening a form modal.
    // there should be a scroll only inside the modal.
    $(document).on('reveal:open', function() {
      $('body').addClass('no-scroll');
    });

    // revert preventing scrolling body when closing a form modal.
    $(document).on('reveal:close', function() {
      $('body').removeClass('no-scroll');
    });
  }
}

function accordionInit() {
  if (document.querySelectorAll('.accordion').length) {
    const accordionSections = document.querySelectorAll('.accordion-section');

    const open = (accordionSection) => {
      accordionSection.classList.add('open');

      const accordionBody = accordionSection.querySelector('.accordion-body');

      accordionBody.style.height = `${
        accordionBody.querySelector('.accordion-inner').offsetHeight
      }px`;
    };

    const close = (accordionSection) => {
      accordionSection.classList.remove('open');

      const accordionBody = accordionSection.querySelector('.accordion-body');

      accordionBody.style.height = 0;
    };

    const isOpen = (accordionSection) => accordionSection.classList.contains('open');

    accordionSections.forEach((accordionSection) => {
      accordionSection.querySelector('.accordion-header').onclick = () => {
        if (!isOpen(accordionSection)) {
          open(accordionSection);
        } else {
          close(accordionSection);
        }
      };
    });
  }
}

function initTwoClickIframes() {
  const twoClickIframes = document.querySelectorAll('.two-click-iframe-preview');

  if (twoClickIframes.length) {
    twoClickIframes.forEach((twoClickIframe) => {
      twoClickIframe.addEventListener('click', (e) => {
        e.preventDefault();

        const iframeSrc = twoClickIframe.dataset.iframeSrc;
        const hasCookiebot = typeof Cookiebot !== 'undefined';
        const isInternal = iframeSrc.indexOf('quirinprivatbank.de') !== -1;

        if (!hasCookiebot || isInternal || (hasCookiebot && Cookiebot.consent.preferences)) {
          // load iframe if there is no Cookiebot or if the preferences cookies are accepted
          const height = twoClickIframe.dataset.iframeHeight || '326px';
          const width = twoClickIframe.dataset.iframeWidth || '100%';

          const iframe = document.createElement('iframe');
          iframe.src = iframeSrc;
          iframe.height = height;
          iframe.width = width;
          iframe.allowFullscreen = true;

          if (iframe && iframeSrc) {
            twoClickIframe.parentNode.replaceChild(iframe, twoClickIframe);
          }
        } else {
          const paragraph = document.createElement('p');
          paragraph.innerHTML = `
            Bitte <a href="javascript: Cookiebot.renew()">Präferenzen-Cookies akzeptieren</a>
            und die Seite neuladen, um externe Inhalte an der Stelle einbinden zu können.
          `;

          twoClickIframe.parentNode.replaceChild(paragraph, twoClickIframe);
        }
      });
    });
  }
}

function jobToolInit() {
  const jobToolInterval = setInterval(() => {
    const jobTool = document.getElementById('job-tool');

    if (jobTool) {
      clearInterval(jobToolInterval);
      ReactDOM.render(<JobTool />, jobTool);
    }
  }, 100);

  // clear the interval after 5 seconds anyways
  setTimeout(() => {
    clearInterval(jobToolInterval);
  }, 5000);
}

function searchInit() {
  const searchInterval = setInterval(() => {
    const search = document.getElementById('search');

    if (search) {
      clearInterval(searchInterval);
      ReactDOM.render(<Search />, search);
    }
  }, 100);

  // clear the interval after 5 seconds anyways
  setTimeout(() => {
    clearInterval(searchInterval);
  }, 5000);
}


function newsDate(article) {
  if (!article.report || !article.report.news_date) { return null; }

  return (
    <span className="color-secondary">
      {article.report.news_date}
      <br />
    </span>
  );
}

function eventInfo(article) {
  if (!article.event || !article.event.event_date) { return null; }

  return (
    <span>
      <i className="fa fa-calendar" /> {article.event.event_date} {article.event.beginning}
      {!!article.event.event_city && <br />}
      {!!article.event.event_city && (
        <i className="fa fa-map-marker" style={{ fontSize: 18, marginLeft: 3, marginRight: 7 }} />
      )}
      {article.event.event_city}
    </span>
  );
}

function pressReleaseInfo(article) {
  if (!article.pressrelease || !article.pressrelease.release_date) { return null; }

  return (
    <span className="color-secondary">
      {article.pressrelease.release_date}
      <br />
    </span>
  );
}

function listTeaserArticleInfo(article) {
  const isEvent = !!article.event.id;

  if (isEvent) {
    return (
      <div>
        <h2 className="margin-bottom-xs">
          <a href={article.publicUrl} title={article.title}>
            {article.title}
          </a>
        </h2>
        <p>{eventInfo(article)}</p>
      </div>
    );
  }

  return (
    <div>
      <p className="no-margin">{newsDate(article) || pressReleaseInfo(article)}</p>
      <h2 className="margin-bottom-xs">
        <a href={article.publicUrl} title={article.title}>
          {article.title}
        </a>
      </h2>
    </div>
  );
}

export {
  correctArticleHeight,
  correctFotoramaArticleHeight,
  contentListItemColor,
  breadcrumbColor,
  showDisclaimer,
  addScrollDownElementOnSectionIfFullscreen,
  componentForArticleType,
  fixFurtherContentHeadlineMargin,
  adjustContentWithBackgroundHeights,
  initModalRevealsForArticle,
  accordionInit,
  initTwoClickIframes,
  jobToolInit,
  searchInit,
  newsDate,
  eventInfo,
  pressReleaseInfo,
  listTeaserArticleInfo
};



// WEBPACK FOOTER //
// ./articleHelper.js